// Mock data for Transformative AI Systems website

export const portfolioCompanies = [
  {
    id: 'lobbylogix',
    name: 'LobbyLogix',
    link: 'https://www.lobbylogix.com',
    description: 'AI-powered front-office automation and customer capture systems that recover missed opportunities, eliminate lead leakage, and turn every inbound interaction into revenue.',
    tagline: 'If your phone rings and nobody answers, we fix the system.',
    capabilities: ['Inbound Capture', 'Lead Recovery', 'Revenue Automation'],
    color: '#00FFD1'
  },
  {
    id: 'shielddeck',
    name: 'ShieldDeck',
    link: 'https://ai-landing-pro-2.preview.emergentagent.com/',
    description: 'A margin protection and revenue defense platform designed for delivery-heavy and commission-exposed businesses.',
    tagline: 'Protect your margins. Defend your revenue.',
    capabilities: ['Margin Protection', 'Revenue Defense', 'Commission Tracking'],
    color: '#7B68EE'
  },
  {
    id: 'statziq',
    name: 'StatzIQ',
    link: 'https://ai-landing-pro-2.preview.emergentagent.com/',
    description: 'A predictive analytics and decision-intelligence engine built for high-stakes modeling and decision support.',
    tagline: 'Intelligence that moves the needle.',
    capabilities: ['Predictive Analytics', 'Decision Support', 'High-Stakes Modeling'],
    color: '#4ECDC4'
  },
  {
    id: 'aligned',
    name: 'Aligned Human Capital',
    link: 'https://ai-landing-pro-2.preview.emergentagent.com/',
    description: 'AI-driven talent alignment and workforce optimization systems that improve hiring accuracy and reduce turnover.',
    tagline: 'Right people. Right roles. Right now.',
    capabilities: ['Talent Alignment', 'Workforce Optimization', 'Hiring Intelligence'],
    color: '#FF6B9D'
  },
  {
    id: 'averitas',
    name: 'Averitas Advisors',
    link: 'https://ai-landing-pro-2.preview.emergentagent.com/',
    description: 'An intelligence-driven advisory platform focused on asset recovery, equity reclamation, and financial resolution services.',
    tagline: 'Recover what\'s yours.',
    capabilities: ['Asset Recovery', 'Equity Reclamation', 'Financial Resolution'],
    color: '#FFD700'
  }
];

export const capabilities = [
  {
    id: 'revenue',
    title: 'Revenue Systems',
    subtitle: 'Capture & Convert',
    items: ['Inbound capture', 'Missed-opportunity recovery', 'Automated follow-up', 'Pipeline enforcement', 'Lead scoring']
  },
  {
    id: 'compliance',
    title: 'Compliance Systems',
    subtitle: 'Protect & Enforce',
    items: ['Drift detection', 'Workflow enforcement', 'Audit-ready evidence', 'Multi-jurisdiction mapping', 'Risk monitoring']
  },
  {
    id: 'decision',
    title: 'Decision Systems',
    subtitle: 'Analyze & Act',
    items: ['Forecasting', 'What-if simulators', 'Anomaly detection', 'KPI intelligence layers', 'Scenario modeling']
  },
  {
    id: 'human-capital',
    title: 'Human-Capital Systems',
    subtitle: 'Align & Optimize',
    items: ['Role fit scoring', 'Retention risk analysis', 'Onboarding automation', 'Performance alignment', 'Talent mapping']
  }
];

export const principles = [
  {
    id: 1,
    title: 'AI should integrate, not disrupt',
    description: 'Technology that works with your existing operations, not against them.'
  },
  {
    id: 2,
    title: 'Systems should enforce reality, not opinions',
    description: 'Data-driven decisions, not gut feelings dressed up as strategy.'
  },
  {
    id: 3,
    title: 'Automation should increase accountability',
    description: 'Transparent systems that make responsibility clear, not hidden.'
  },
  {
    id: 4,
    title: 'Technology should earn its keep',
    description: 'Every system must justify its existence through measurable outcomes.'
  }
];

export const whatWeDoItems = [
  {
    id: 1,
    title: 'Capture',
    subtitle: 'what\'s being missed',
    description: 'Identify and recover opportunities slipping through the cracks.'
  },
  {
    id: 2,
    title: 'Protect',
    subtitle: 'what\'s being lost',
    description: 'Defend margins, revenue, and resources from silent erosion.'
  },
  {
    id: 3,
    title: 'Optimize',
    subtitle: 'what already exists',
    description: 'Make current systems work harder and smarter.'
  },
  {
    id: 4,
    title: 'Scale',
    subtitle: 'without adding headcount',
    description: 'Grow capacity through intelligence, not just bodies.'
  }
];

export const systemOptions = [
  { value: 'revenue', label: 'Revenue' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'decisioning', label: 'Decisioning' },
  { value: 'human-capital', label: 'Human Capital' },
  { value: 'other', label: 'Other' }
];

export const navLinks = [
  { href: '#what-we-do', label: 'What We Do' },
  { href: '#systems', label: 'Systems' },
  { href: '#philosophy', label: 'Philosophy' },
  { href: '#capabilities', label: 'Capabilities' },
  { href: '/about', label: 'About', isPage: true },
  { href: '#contact', label: 'Contact' }
];

export const companyLogos = {
  mainDark: 'https://customer-assets.emergentagent.com/job_c5e35fd0-dca6-4a17-835c-2da92b3bd579/artifacts/rr2108es_B52D619E-85B6-4CE4-B22C-A51082310DF0.png',
  mainLight: 'https://customer-assets.emergentagent.com/job_c5e35fd0-dca6-4a17-835c-2da92b3bd579/artifacts/2wo2k31v_BDEAD474-D3BD-404B-B750-E6EAA225CC5A.png',
  averitas: 'https://customer-assets.emergentagent.com/job_c5e35fd0-dca6-4a17-835c-2da92b3bd579/artifacts/f8otin8e_PNG%20image.jpeg',
  statziq: 'https://customer-assets.emergentagent.com/job_galaxy-ai-systems/artifacts/nxa8flj4_2AE3850F-6DF5-4F58-942C-F0A9C9853A0C.png',
  lobbylogix: 'https://customer-assets.emergentagent.com/job_galaxy-ai-systems/artifacts/opp8za49_IMG_6153.jpeg',
  shielddeck: 'https://customer-assets.emergentagent.com/job_galaxy-ai-systems/artifacts/3ibtdeis_082DA313-C40E-4240-B2E7-278FBCE923B1.png',
  aligned: 'https://customer-assets.emergentagent.com/job_galaxy-ai-systems/artifacts/jl8gbkno_AE932904-BEDB-4974-AA27-8D9276CBD2C5.png',
  ceoHeadshot: 'https://customer-assets.emergentagent.com/job_ai-landing-pro-2/artifacts/quj52eva_IMG_8365.jpeg'
};
